import React from "react";
import CountUp from "react-countup";
import { Award, Users, PenTool, Trophy } from "lucide-react";

const countData = [
  { id: 1, icon: <Trophy size={28} />, number: 7, suffix: "+", label: "Years of Experience" },
  { id: 2, icon: <Award size={28} />, number: 15, suffix: "+", label: "Awards & Recognition" },
  { id: 3, icon: <PenTool size={28} />, number: 50, suffix: "+", label: "Blogs Published" },
  { id: 4, icon: <Users size={28} />, number: 100, suffix: "+", label: "Lives Impacted" },
];

const CountUpCards = () => {
  return (
    <div className="hob-countup-container">
      {countData.map((item) => (
        <div key={item.id} className="hob-countup-card">
          <div className="hob-countup-icon">{item.icon}</div>
          <h2 className="hob-countup-number">
            <CountUp end={item.number} duration={2.5} />{item.suffix}
          </h2>
          <p className="hob-countup-label">{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default CountUpCards;
